import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Aigenerated from '../components/Aigenerated'

function CreateInvoiceByAIPage() {
    return (
        <>
            <MasterLayout>
                {/* <InoiveAddByAIForm />
                 */}
                 <Aigenerated/>
            </MasterLayout>
        </>
    )
}

export default CreateInvoiceByAIPage
